import React from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';
import Icon from 'components/Icon';
import classNames from 'classnames';

interface StatCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
  icon: string;
  iconBgColor?: string;
  iconColor?: string;
  isLoading?: boolean;
  onClick?: () => void;
}

const StatCard = ({
  title,
  value,
  subtitle,
  icon,
  iconBgColor = 'bg-primary',
  iconColor = 'text-white',
  isLoading = false,
  onClick
}: StatCardProps) => {
  return (
    <Card
      className={classNames('border-0 shadow-sm h-100', {
        'cursor-pointer': !!onClick
      })}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <CardBody className="d-flex align-items-center p-4">
        <div
          className={classNames(
            'rounded-circle d-flex align-items-center justify-content-center me-3',
            iconBgColor
          )}
          style={{ width: '56px', height: '56px', minWidth: '56px' }}
        >
          <Icon icon={icon} className={iconColor} width={28} height={28} />
        </div>
        <div className="flex-grow-1">
          <p className="text-muted small mb-1 text-uppercase fw-semibold">
            {title}
          </p>
          {isLoading ? (
            <Spinner size="sm" color="primary" />
          ) : (
            <>
              <h3 className="mb-0 fw-bold">{value}</h3>
              {subtitle && <small className="text-muted">{subtitle}</small>}
            </>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default StatCard;
